<template>
  <div>
    <App v-model="bindShow" :shareConfig="shareConfig" v-if="inAPP" />
    <Browser v-model="bindShow" :shareConfig="shareConfig" v-else />
  </div>
</template>

<script>
import { env } from '@zyf2e/adapt';
import App from './app';
import Browser from './browser';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    shareConfig: Object
  },
  components: {
    App,
    Browser
  },
  data() {
    return {
      inAPP: env.inAPP
    };
  },
  computed: {
    bindShow: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
